import {Variable} from './variable';
import {AssessmentResult} from '../../shared/models/assessment-result';
import {IReportItemComponent} from './i-report-item-component';
import { ScaleResult } from 'app/shared/models/scale-result';
import { BaseReportItemComponent } from "./base-report-item-component";

export abstract class ScaleDataSectionComponent extends BaseReportItemComponent implements IReportItemComponent {
    
      private _assessmentResult:AssessmentResult;
      private _scaleResults:ScaleResult[];

      constructor() {
        super();
        this._scaleResults = [];
      }
    
      public setReportData(data:any, results:AssessmentResult[], variables:Variable[]) {
        if (!data || !results) {
          return;
        }
        if (data.assessment) {
          this._assessmentResult = results.find(r => r.assessment.uid == data.assessment);
        }
        else if (data.computed_result) {
          this._assessmentResult = results.find(r => r.id === data.computed_result);
        }
        if (this._assessmentResult) {
          // normally we take all the scales... but we can filter them here
          if (data.scales && data.scales.length) {
            this._scaleResults = this._assessmentResult.scaleResults
              .filter(sr => data.scales.indexOf(sr.scale.id) >= 0);
          }
          else {
            this._scaleResults = this._assessmentResult.scaleResults;
          }
          this._assessmentResult.scaleResults.forEach(s => console.log(this._assessmentResult.assessment.name, "=>",s.scale.name , "(", s.scale.id, ")"));
        }
      }
    
      ngOnInit() {
        
      }
      ngAfterViewInit() {
        super.ngAfterViewInit();
      }
    
      get ScaleResults() {
        return this._scaleResults;
      }
      get AssessmentResult() {
        return this._assessmentResult;
      }
      set AssessmentResult(v:AssessmentResult) {
        this._assessmentResult = v;
      }
    }
    


// WEBPACK FOOTER //
// ./src/app/reports/models/scale-list-data-component.ts